// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const BrowserMatchLocationSchema = z.enum(['REQUEST','RESPONSE','BOTH'] as const);

export type BrowserMatchLocationType = `${z.infer<typeof BrowserMatchLocationSchema>}`

export default BrowserMatchLocationSchema;
